import React, {useCallback, useMemo} from 'react';
import _ from 'lodash';
import {Form, Formik} from 'formik';
import {Btn, CheckboxDropdown, Icon} from '../../../../ui-toolkit';
import styled from 'styled-components';
import {getPathDetails} from '../../../../ducks/formattersettingshelpers';
import {usePreferences} from '../../../../ducks/PreferencesContext';
import {DropdownBtn} from '../../../../ui-toolkit/custom-feature/checkbox-dropdown/CheckboxDropdownStructure';

export function ColumnSelectionDropdown({formatter, entityType, t}) {
    const {preferences, setPreference} = usePreferences();

    const formatterAttributes = useMemo(() => {
        return _.filter(
            _.get(formatter, 'settings.attributes', []),
            (attr) => getPathDetails(entityType, attr.attributePath).validPath,
        );
    }, [entityType]);
    const shownColumns = _.get(preferences, 'shownColumns', []);

    const setShownColumns = useCallback(
        (cols) => {
            setPreference('shownColumns', cols);
        },
        [setPreference],
    );

    const columnDropdownOptions = useMemo(
        () =>
            formatterAttributes.map((attr) => {
                return {id: '' + attr.uniqueId, name: attr.displayName};
            }),
        [formatterAttributes],
    );

    function submitForm({showColumns}) {
        setShownColumns(_.map(showColumns, (x) => +x)); // cast to int, stored in form as string
    }

    return (
        <Wrapper>
            <Formik initialValues={{showColumns: _.map(shownColumns, (c) => '' + c)}} onSubmit={submitForm}>
                {({submitForm}) => (
                    <Form>
                        <CheckboxDropdown
                            options={columnDropdownOptions}
                            name="showColumns"
                            footer={(close) => (
                                <Btn
                                    color="success"
                                    onClick={() => {
                                        submitForm();
                                        close();
                                    }}>
                                    <Icon name="save" /> {t('entityTable.saveColumnSelection')}
                                </Btn>
                            )}>
                            <Icon name="settings" />
                        </CheckboxDropdown>
                    </Form>
                )}
            </Formik>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    display: flex !important;
    align-items: center;
    gap: 4px;
    ${DropdownBtn} {
        min-height: 28px;
        margin-bottom: 1px;
    }
`;
